/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable, ApplicationRef } from '@angular/core';
import { IceNavService } from '../../../../projects/icemedx-lib/src/components/ice-nav/ice-nav.service';
import { BaseAppService } from '../../../../projects/icemedx-lib/src/services/baseapp.service';
import { DomainService } from 'projects/icemedx-lib/src/services/domain/domain.service';
import { LoginConfig } from '../../../../projects/icemedx-lib/src/login/login.config';
import { environment } from "../../src/environments/environment";
import { LoginService } from '../../../icemedx-lib/src/login/login.service';

declare var require: any;

@Injectable()
export class AppService extends BaseAppService {

  constructor(navSvc: IceNavService, domainSvc: DomainService, loginSvc: LoginService, app: ApplicationRef) {
    super(navSvc, domainSvc, loginSvc, app);
  }

  public defaultMenus() {
    super.defaultMenus();
    //super.getNavService().insertSideRoute(null, "dashboard", null, "dashboard", "Dashboard", "fas fa-tachometer-alt", 0);
  }

  public getBaseRoutePath(routeName: string): string {
    if (routeName == null || routeName.length == 0) return "";

    let app_path: string = "";
    let currentEnv: any = require("../../../../env.json").currentEnv;
    let envs: any = require("../../../../env.json").environments;
    if (envs != null) {
      app_path = envs[currentEnv].app_path;
      app_path = LoginConfig.getFormattedPath(app_path, routeName, true);
    }
    return app_path;
  }
}
